import { clearButtonStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchClearButton";

Object.assign(clearButtonStyles, {
    clearButton: {
        variant: "secondary",
    },
});
